// ─── Pharmacist Advisor — case data ─────────────────────────────────────────

export const PHARMACIST_CASES = [
  {
    id: "athletes-foot",
    client: {
      name: "Marcus",
      age: 22,
      sprite: "/blobavatar/blob.beerman.png",
      color: "#f97316",
      complaint:
        "I've got really itchy, flaky skin between my toes — it's been there about two weeks. It started after I joined a new gym.",
      flags: [],
    },
    medications: [
      {
        id: "terbinafine",
        name: "Terbinafine 1% cream",
        category: "Antifungal",
        correct: true,
      },
      {
        id: "hydrocortisone",
        name: "Hydrocortisone 1% cream",
        category: "Topical corticosteroid",
        correct: false,
        feedback:
          "Hydrocortisone alone would suppress the immune response and actually worsen a fungal infection. Never use steroids on undiagnosed skin rashes without ruling out fungal infection.",
      },
      {
        id: "fusidic-acid",
        name: "Fusidic acid cream",
        category: "Topical antibiotic",
        correct: false,
        feedback:
          "Fusidic acid treats bacterial infections like impetigo — it has no antifungal activity and won't help athlete's foot.",
      },
      {
        id: "calamine",
        name: "Calamine lotion",
        category: "Soothing lotion",
        correct: false,
        feedback:
          "Calamine soothes irritated skin but has no antifungal properties — it won't treat the underlying tinea pedis infection.",
      },
    ],
    correctFeedback:
      "Terbinafine cream is first-line for tinea pedis (athlete's foot). It's fungicidal — it kills the fungus rather than just slowing growth — and usually clears infection within 1–2 weeks.",
    counsellingPoints: [
      {
        id: "c1",
        text: "Apply to the affected area once daily for 1–2 weeks, even if it looks better sooner",
        correct: true,
      },
      {
        id: "c2",
        text: "Keep feet dry — dry thoroughly between toes after washing",
        correct: true,
      },
      {
        id: "c3",
        text: "Wear clean cotton socks and avoid walking barefoot in communal areas like gym showers",
        correct: true,
      },
      {
        id: "c4",
        text: "See your GP if no improvement after 2 weeks",
        correct: true,
      },
      {
        id: "c5",
        text: "Cover the whole foot in cream, not just between the toes",
        correct: false,
      },
      {
        id: "c6",
        text: "Stop as soon as itching resolves — you don't need to finish the course",
        correct: false,
      },
    ],
  },
  {
    id: "constipation",
    client: {
      name: "Mrs. Obi",
      age: 67,
      sprite: "/blobavatar/blob.doctor.blue.png",
      color: "#8b5cf6",
      complaint:
        "I haven't had a bowel movement in 5 days. My stools are very hard when I do go. I take amlodipine for blood pressure.",
      flags: ["Takes amlodipine (calcium channel blocker)"],
    },
    medications: [
      {
        id: "macrogol",
        name: "Macrogol (Movicol) sachets",
        category: "Osmotic laxative",
        correct: true,
      },
      {
        id: "codeine",
        name: "Codeine 30 mg",
        category: "Opioid analgesic",
        correct: false,
        feedback:
          "Codeine is an opioid and one of the most common causes of constipation — prescribing it here would dramatically worsen symptoms.",
      },
      {
        id: "ibuprofen",
        name: "Ibuprofen 400 mg",
        category: "NSAID",
        correct: false,
        feedback:
          "NSAIDs treat pain and inflammation but have no laxative effect. Ibuprofen also carries renal risk in elderly patients.",
      },
      {
        id: "loperamide",
        name: "Loperamide 2 mg",
        category: "Anti-diarrhoeal",
        correct: false,
        feedback:
          "Loperamide slows gut motility — giving it to someone who is already constipated could cause serious harm.",
      },
    ],
    correctFeedback:
      "Macrogol (polyethylene glycol) is a first-line osmotic laxative — it draws water into the bowel to soften stool. It is safe in the elderly and has no significant interaction with amlodipine.",
    counsellingPoints: [
      {
        id: "c1",
        text: "Dissolve each sachet in a full glass of water and drink it all",
        correct: true,
      },
      {
        id: "c2",
        text: "Increase fluid intake and dietary fibre (fruits, vegetables, wholegrains)",
        correct: true,
      },
      {
        id: "c3",
        text: "Gentle activity such as walking can help stimulate bowel movement",
        correct: true,
      },
      {
        id: "c4",
        text: "See GP if constipation persists beyond 2 weeks or is associated with rectal bleeding or weight loss",
        correct: true,
      },
      {
        id: "c5",
        text: "Double the dose on the first day for faster results",
        correct: false,
      },
      {
        id: "c6",
        text: "Restrict fluid intake so the macrogol works more efficiently",
        correct: false,
      },
    ],
  },
  {
    id: "vaginal-thrush",
    client: {
      name: "Priya",
      age: 31,
      sprite: "/blobavatar/blob.doctor.blue.png",
      color: "#ec4899",
      complaint:
        "I have vaginal itching and a thick white discharge — this has happened to me before and it was thrush. Not pregnant.",
      flags: [],
    },
    medications: [
      {
        id: "clotrimazole",
        name: "Clotrimazole 500 mg pessary + cream",
        category: "Antifungal (topical)",
        correct: true,
      },
      {
        id: "metronidazole",
        name: "Metronidazole 400 mg",
        category: "Antibiotic / antiprotozoal",
        correct: false,
        feedback:
          "Metronidazole treats bacterial vaginosis and trichomoniasis — it has no activity against Candida. Using it for thrush would be ineffective and risk unnecessary antibiotic exposure.",
      },
      {
        id: "hydrocortisone",
        name: "Hydrocortisone 1% cream",
        category: "Topical corticosteroid",
        correct: false,
        feedback:
          "Hydrocortisone alone would suppress local immunity and worsen a Candida infection. It should never be used as sole treatment for thrush.",
      },
      {
        id: "amoxicillin",
        name: "Amoxicillin 500 mg",
        category: "Antibiotic",
        correct: false,
        feedback:
          "Amoxicillin is an antibacterial with no antifungal properties. Broad-spectrum antibiotics actually increase the risk of thrush by disrupting the normal bacterial flora.",
      },
    ],
    correctFeedback:
      "Clotrimazole 500 mg pessary (single-dose intravaginal) combined with the external cream for itch is first-line OTC treatment for uncomplicated vulvovaginal candidiasis.",
    counsellingPoints: [
      {
        id: "c1",
        text: "Insert the pessary at night — lying down helps it stay in place",
        correct: true,
      },
      {
        id: "c2",
        text: "Apply the external cream to the vulva 2–3 times daily to relieve itch",
        correct: true,
      },
      {
        id: "c3",
        text: "Clotrimazole can damage latex condoms and diaphragms — use alternative contraception",
        correct: true,
      },
      {
        id: "c4",
        text: "Return if symptoms don't resolve within 7 days, recur frequently, or if partner has symptoms",
        correct: true,
      },
      {
        id: "c5",
        text: "Share the cream with your partner as a precaution — treat them at the same time",
        correct: false,
      },
      {
        id: "c6",
        text: "Take a course of oral antibiotics alongside to prevent secondary infection",
        correct: false,
      },
    ],
  },
  {
    id: "cold-sore",
    client: {
      name: "Jamie",
      age: 17,
      sprite: "/blobavatar/blob.beerman.png",
      color: "#64748b",
      complaint:
        "I can feel a cold sore starting on my lip — it's tingling and a small blister is just appearing. I get these a few times a year.",
      flags: [],
    },
    medications: [
      {
        id: "aciclovir",
        name: "Aciclovir 5% cream",
        category: "Topical antiviral",
        correct: true,
      },
      {
        id: "fusidic-acid",
        name: "Fusidic acid cream",
        category: "Topical antibiotic",
        correct: false,
        feedback:
          "Fusidic acid is an antibacterial — it has no activity against herpes simplex virus (HSV), which causes cold sores.",
      },
      {
        id: "terbinafine",
        name: "Terbinafine 1% cream",
        category: "Antifungal",
        correct: false,
        feedback:
          "Terbinafine is an antifungal — it won't treat a viral infection like herpes simplex.",
      },
      {
        id: "chloramphenicol",
        name: "Chloramphenicol eye ointment",
        category: "Antibiotic (ophthalmic)",
        correct: false,
        feedback:
          "Chloramphenicol eye ointment is for bacterial eye infections and is not appropriate for oral HSV lesions.",
      },
    ],
    correctFeedback:
      "Aciclovir 5% cream inhibits HSV DNA polymerase. It works best when started at the first sign of tingling — early treatment reduces healing time and severity.",
    counsellingPoints: [
      {
        id: "c1",
        text: "Apply 5 times daily at roughly 4-hourly intervals for 5 days",
        correct: true,
      },
      {
        id: "c2",
        text: "Start as early as possible — at the first tingle, before the blister appears fully",
        correct: true,
      },
      {
        id: "c3",
        text: "Avoid kissing and oral contact until the sore has fully healed",
        correct: true,
      },
      {
        id: "c4",
        text: "Do not share towels, lip balm or cutlery while the sore is active",
        correct: true,
      },
      {
        id: "c5",
        text: "Apply a thick layer and rub it vigorously into the blister to burst it",
        correct: false,
      },
      {
        id: "c6",
        text: "Stop applying as soon as the blister appears — cream only works before the blister forms",
        correct: false,
      },
    ],
  },
  {
    id: "head-lice",
    client: {
      name: "Mrs. Brennan",
      age: 38,
      sprite: "/blobavatar/blob.doctor.blue.png",
      color: "#10b981",
      complaint:
        "My 6-year-old daughter has been scratching her head for a week. I found small brown insects and white eggs in her hair. She's otherwise well.",
      flags: ["Treating a child (age 6)"],
    },
    medications: [
      {
        id: "dimeticone",
        name: "Dimeticone 4% lotion (Hedrin)",
        category: "Physical insecticide (silicone-based)",
        correct: true,
      },
      {
        id: "permethrin",
        name: "Permethrin 1% cream rinse",
        category: "Chemical insecticide",
        correct: false,
        feedback:
          "Permethrin is no longer first-line in many regions due to widespread resistance in head lice populations. Dimeticone works by a physical mechanism so resistance is not a concern.",
      },
      {
        id: "terbinafine",
        name: "Terbinafine 1% cream",
        category: "Antifungal",
        correct: false,
        feedback:
          "Terbinafine is for fungal skin infections — it has no effect whatsoever on head lice.",
      },
      {
        id: "hydrocortisone",
        name: "Hydrocortisone 1% cream",
        category: "Topical corticosteroid",
        correct: false,
        feedback:
          "Hydrocortisone may temporarily relieve scalp itch but does nothing to eliminate the lice or eggs. This is not appropriate as sole treatment.",
      },
    ],
    correctFeedback:
      "Dimeticone (silicone-based) works by physically coating and suffocating lice — it doesn't rely on neurotoxicity so there's no resistance risk. It's suitable from age 6 months.",
    counsellingPoints: [
      {
        id: "c1",
        text: "Apply to dry hair, leave for 8 hours (or overnight), then wash off",
        correct: true,
      },
      {
        id: "c2",
        text: "Repeat treatment after 7 days to kill any lice that hatched from eggs after the first application",
        correct: true,
      },
      {
        id: "c3",
        text: "Use a fine-toothed detection comb (wet combing) after each application to remove dead lice and eggs",
        correct: true,
      },
      {
        id: "c4",
        text: "Check and treat all household members who have close head contact",
        correct: true,
      },
      {
        id: "c5",
        text: "Wash all bedding at 60°C immediately — lice spread primarily through bedding",
        correct: false,
      },
      {
        id: "c6",
        text: "One application is always sufficient — no need to repeat",
        correct: false,
      },
    ],
  },
  {
    id: "haemorrhoids",
    client: {
      name: "Greg",
      age: 44,
      sprite: "/blobavatar/blob.moneyman.png",
      color: "#78716c",
      complaint:
        "I have itching and mild discomfort around my back passage, especially after going to the toilet. I've noticed a little bright red blood on the tissue. No pain at rest.",
      flags: [],
    },
    medications: [
      {
        id: "anusol",
        name: "Anusol cream (zinc oxide + bismuth)",
        category: "Haemorrhoid preparation",
        correct: true,
      },
      {
        id: "ibuprofen",
        name: "Ibuprofen 400 mg",
        category: "NSAID",
        correct: false,
        feedback:
          "Oral NSAIDs won't treat the local symptoms of haemorrhoids effectively and can worsen GI side-effects. A topical preparation is appropriate here.",
      },
      {
        id: "loperamide",
        name: "Loperamide 2 mg",
        category: "Anti-diarrhoeal",
        correct: false,
        feedback:
          "Loperamide is for diarrhoea. Hard stools worsen haemorrhoids, so reducing gut motility could actually make symptoms worse.",
      },
      {
        id: "clotrimazole",
        name: "Clotrimazole 1% cream",
        category: "Antifungal",
        correct: false,
        feedback:
          "Clotrimazole treats fungal infections — it has no role in managing haemorrhoids.",
      },
    ],
    correctFeedback:
      "Anusol (containing zinc oxide, bismuth subgallate and Peru balsam) is a standard OTC haemorrhoid preparation — it soothes, astringes and protects the anal mucosa.",
    counsellingPoints: [
      {
        id: "c1",
        text: "Apply after each bowel movement and at night",
        correct: true,
      },
      {
        id: "c2",
        text: "Increase dietary fibre and fluid intake to soften stools and reduce straining",
        correct: true,
      },
      {
        id: "c3",
        text: "Avoid prolonged sitting on the toilet — straining worsens haemorrhoids",
        correct: true,
      },
      {
        id: "c4",
        text: "See GP if bleeding persists beyond 2 weeks, or if there is any change in bowel habit — rectal bleeding always needs follow-up",
        correct: true,
      },
      {
        id: "c5",
        text: "Apply inside the rectum with your finger for best results",
        correct: false,
      },
      {
        id: "c6",
        text: "Restrict fluid intake to reduce swelling around the area",
        correct: false,
      },
    ],
  },
  {
    id: "insomnia",
    client: {
      name: "Diane",
      age: 55,
      sprite: "/blobavatar/blob.doctor.blue.png",
      color: "#7c3aed",
      complaint:
        "I've had trouble falling asleep for the past 2 weeks — I think it's stress related. I don't take any regular medications.",
      flags: [],
    },
    medications: [
      {
        id: "diphenhydramine",
        name: "Diphenhydramine 25 mg (Nytol)",
        category: "Sedating antihistamine",
        correct: true,
      },
      {
        id: "loratadine",
        name: "Loratadine 10 mg",
        category: "Non-drowsy antihistamine",
        correct: false,
        feedback:
          "Loratadine is specifically formulated to be non-sedating — it's the wrong choice for someone who needs help sleeping.",
      },
      {
        id: "ibuprofen",
        name: "Ibuprofen 400 mg",
        category: "NSAID",
        correct: false,
        feedback:
          "Ibuprofen has no sedative properties and is not appropriate for insomnia.",
      },
      {
        id: "omeprazole",
        name: "Omeprazole 20 mg",
        category: "Proton pump inhibitor",
        correct: false,
        feedback:
          "Omeprazole has no sedative effect — it reduces gastric acid and is entirely unrelated to sleep.",
      },
    ],
    correctFeedback:
      "Diphenhydramine (an H1 antihistamine) has sedative properties and is the only licensed OTC sleep aid in many countries. It is suitable for short-term use only.",
    counsellingPoints: [
      {
        id: "c1",
        text: "For short-term use only — no more than 2 consecutive weeks",
        correct: true,
      },
      {
        id: "c2",
        text: "May cause next-day drowsiness — avoid driving or operating machinery",
        correct: true,
      },
      {
        id: "c3",
        text: "Avoid alcohol — it potentiates sedation",
        correct: true,
      },
      {
        id: "c4",
        text: "Address the underlying cause — sleep hygiene advice: regular sleep schedule, cool dark room, limit screens before bed",
        correct: true,
      },
      {
        id: "c5",
        text: "Safe to use nightly indefinitely if it continues to help",
        correct: false,
      },
      {
        id: "c6",
        text: "Can be safely combined with other antihistamines for extra effect",
        correct: false,
      },
    ],
  },
  {
    id: "uti-symptoms",
    client: {
      name: "Nina",
      age: 26,
      sprite: "/blobavatar/blob.doctor.blue.png",
      color: "#0ea5e9",
      complaint:
        "I have a burning sensation when I urinate and need to go much more frequently. No fever, no back pain, no vaginal discharge. This has happened once before.",
      flags: [],
    },
    medications: [
      {
        id: "sodium-citrate",
        name: "Sodium citrate sachets (Cystopurin)",
        category: "Urinary alkalinising agent",
        correct: true,
      },
      {
        id: "amoxicillin",
        name: "Amoxicillin 500 mg",
        category: "Antibiotic",
        correct: false,
        feedback:
          "Antibiotics require a prescription for UTIs in most settings — OTC supply is not appropriate. Sodium citrate can relieve symptoms while the patient is assessed, but a urine culture and prescription antibiotic is the definitive treatment.",
      },
      {
        id: "ibuprofen",
        name: "Ibuprofen 400 mg",
        category: "NSAID",
        correct: false,
        feedback:
          "While ibuprofen may reduce discomfort, there is some evidence NSAIDs can worsen uncomplicated UTIs by suppressing the immune response needed to clear the infection. Sodium citrate is more appropriate here.",
      },
      {
        id: "loperamide",
        name: "Loperamide 2 mg",
        category: "Anti-diarrhoeal",
        correct: false,
        feedback:
          "Loperamide has no role in treating urinary symptoms — it acts on the gut, not the urinary tract.",
      },
    ],
    correctFeedback:
      "Sodium citrate alkalinises the urine, which reduces the burning sensation of cystitis. It is symptomatic relief only — you should advise Nina to see her GP if symptoms persist beyond 2 days, as antibiotics are likely needed.",
    counsellingPoints: [
      {
        id: "c1",
        text: "Dissolve sachets in water and drink plenty of fluids throughout the day",
        correct: true,
      },
      {
        id: "c2",
        text: "This is symptomatic relief only — see GP if no improvement within 48 hours",
        correct: true,
      },
      {
        id: "c3",
        text: "Seek urgent GP review if fever, rigors, loin pain or vomiting develop — these suggest upper urinary tract infection",
        correct: true,
      },
      {
        id: "c4",
        text: "Avoid sodium citrate if you have kidney disease or are on a sodium-restricted diet",
        correct: true,
      },
      {
        id: "c5",
        text: "Sodium citrate will cure the infection — antibiotics are not needed",
        correct: false,
      },
      {
        id: "c6",
        text: "Restrict fluid intake to reduce how often you need to urinate",
        correct: false,
      },
    ],
  },
  {
    id: "allergic-rhinitis",
    client: {
      name: "Sarah",
      age: 28,
      sprite: "/blobavatar/blob.doctor.blue.png",
      color: "#3b82f6",
      complaint:
        "I've had a runny nose, constant sneezing and itchy eyes for the past week. It happens every spring. No fever.",
      flags: [],
    },
    medications: [
      {
        id: "loratadine",
        name: "Loratadine 10 mg",
        category: "Non-drowsy antihistamine",
        correct: true,
      },
      {
        id: "pseudoephedrine",
        name: "Pseudoephedrine 60 mg",
        category: "Nasal decongestant",
        correct: false,
        feedback:
          "Pseudoephedrine helps with nasal congestion but not sneezing or itchy eyes. It also raises blood pressure — not first-line here.",
      },
      {
        id: "ibuprofen",
        name: "Ibuprofen 400 mg",
        category: "NSAID",
        correct: false,
        feedback:
          "Ibuprofen reduces pain and inflammation but has no antihistamine effect and won't help allergic rhinitis.",
      },
      {
        id: "loperamide",
        name: "Loperamide 2 mg",
        category: "Anti-diarrhoeal",
        correct: false,
        feedback:
          "Loperamide is for diarrhoea — completely unrelated to allergic rhinitis.",
      },
    ],
    correctFeedback:
      "Loratadine is first-line for allergic rhinitis. It blocks H1 receptors, relieving sneezing, itch and runny nose without causing significant sedation.",
    counsellingPoints: [
      {
        id: "c1",
        text: "Take once daily — works best taken regularly during pollen season",
        correct: true,
      },
      {
        id: "c2",
        text: "Non-drowsy, but some people may still feel mild sedation — caution when driving",
        correct: true,
      },
      {
        id: "c3",
        text: "Return if symptoms don't improve after 2 weeks",
        correct: true,
      },
      {
        id: "c4",
        text: "A saline nasal rinse can be used alongside for extra relief",
        correct: true,
      },
      {
        id: "c5",
        text: "Must be taken with a full glass of milk",
        correct: false,
      },
      {
        id: "c6",
        text: "Always causes significant drowsiness — do not drive",
        correct: false,
      },
    ],
  },
  {
    id: "headache-pregnant",
    client: {
      name: "Emma",
      age: 24,
      sprite: "/blobavatar/blob.doctor.blue.png",
      color: "#ec4899",
      complaint:
        "I have a mild tension headache today. I should mention — I'm 16 weeks pregnant.",
      flags: ["Pregnant (16 weeks)"],
    },
    medications: [
      {
        id: "paracetamol",
        name: "Paracetamol 500 mg",
        category: "Analgesic",
        correct: true,
      },
      {
        id: "ibuprofen",
        name: "Ibuprofen 400 mg",
        category: "NSAID",
        correct: false,
        feedback:
          "Ibuprofen is contraindicated in pregnancy — especially after 20 weeks (risk of premature closure of the ductus arteriosus and oligohydramnios).",
      },
      {
        id: "aspirin",
        name: "Aspirin 300 mg",
        category: "NSAID / antiplatelet",
        correct: false,
        feedback:
          "Standard-dose aspirin is avoided in pregnancy due to bleeding risk and association with Reye's syndrome. Low-dose (75 mg) has specific indications but is not for analgesia.",
      },
      {
        id: "codeine",
        name: "Codeine 30 mg",
        category: "Opioid analgesic",
        correct: false,
        feedback:
          "Codeine should be avoided in pregnancy — it crosses the placenta, can cause neonatal withdrawal, and is not recommended for mild headache.",
      },
    ],
    correctFeedback:
      "Paracetamol is the safest OTC analgesic in pregnancy at recommended doses. NSAIDs and opioids are avoided. Good call!",
    counsellingPoints: [
      {
        id: "c1",
        text: "Paracetamol is the safest OTC painkiller in pregnancy",
        correct: true,
      },
      {
        id: "c2",
        text: "Do not exceed 4 g (8 × 500 mg tablets) in 24 hours",
        correct: true,
      },
      {
        id: "c3",
        text: "See your GP if headaches are frequent, severe, or come with visual disturbance",
        correct: true,
      },
      {
        id: "c4",
        text: "Stay hydrated — dehydration is a common headache trigger",
        correct: true,
      },
      {
        id: "c5",
        text: "Safe to take every day throughout pregnancy without any review",
        correct: false,
      },
      {
        id: "c6",
        text: "Double the dose if the pain is severe",
        correct: false,
      },
    ],
  },
  {
    id: "heartburn",
    client: {
      name: "Mr. Davies",
      age: 52,
      sprite: "/blobavatar/blob.moneyman.png",
      color: "#6b7280",
      complaint:
        "I get a burning feeling in my chest after meals, especially in the evening. It's been going on about 3 weeks.",
      flags: [],
    },
    medications: [
      {
        id: "omeprazole",
        name: "Omeprazole 20 mg",
        category: "Proton pump inhibitor",
        correct: true,
      },
      {
        id: "ibuprofen",
        name: "Ibuprofen 400 mg",
        category: "NSAID",
        correct: false,
        feedback:
          "NSAIDs like ibuprofen inhibit prostaglandins that protect the gastric mucosa — they would make heartburn and dyspepsia significantly worse!",
      },
      {
        id: "loratadine",
        name: "Loratadine 10 mg",
        category: "Antihistamine",
        correct: false,
        feedback:
          "Antihistamines (H1 blockers) don't suppress gastric acid. You'd need an H2 blocker or PPI for heartburn.",
      },
      {
        id: "loperamide",
        name: "Loperamide 2 mg",
        category: "Anti-diarrhoeal",
        correct: false,
        feedback:
          "Loperamide slows gut motility and treats diarrhoea — it has no effect on acid reflux.",
      },
    ],
    correctFeedback:
      "Omeprazole is a proton pump inhibitor — it reduces gastric acid production and is first-line OTC treatment for heartburn and dyspepsia. Well done!",
    counsellingPoints: [
      {
        id: "c1",
        text: "Take 30 minutes before breakfast for best effect",
        correct: true,
      },
      {
        id: "c2",
        text: "OTC use should be limited to 2–4 weeks — see GP if symptoms persist",
        correct: true,
      },
      {
        id: "c3",
        text: "Lifestyle: avoid large meals, fatty food, alcohol, and lying down after eating",
        correct: true,
      },
      {
        id: "c4",
        text: "See a GP urgently if there is difficulty swallowing, weight loss, or vomiting blood",
        correct: true,
      },
      {
        id: "c5",
        text: "Safe to take indefinitely without any medical review",
        correct: false,
      },
      {
        id: "c6",
        text: "Best taken just before bed for maximum overnight effect",
        correct: false,
      },
    ],
  },
  {
    id: "diarrhoea",
    client: {
      name: "Tom",
      age: 19,
      sprite: "/blobavatar/blob.beerman.png",
      color: "#f59e0b",
      complaint:
        "I've had loose stools since yesterday — about 4–5 times. No blood, no fever. Probably something I ate at a BBQ.",
      flags: [],
    },
    medications: [
      {
        id: "loperamide-ors",
        name: "Loperamide + ORS sachets",
        category: "Anti-diarrhoeal + oral rehydration",
        correct: true,
      },
      {
        id: "amoxicillin",
        name: "Amoxicillin 500 mg",
        category: "Antibiotic",
        correct: false,
        feedback:
          "Antibiotics are not recommended for simple gastroenteritis — most cases are viral or self-limiting bacterial. Antibiotics can even prolong Salmonella shedding.",
      },
      {
        id: "ibuprofen",
        name: "Ibuprofen 400 mg",
        category: "NSAID",
        correct: false,
        feedback:
          "NSAIDs can irritate the gut lining and are not appropriate for gastroenteritis. Paracetamol is preferred if pain relief is needed.",
      },
      {
        id: "omeprazole",
        name: "Omeprazole 20 mg",
        category: "Proton pump inhibitor",
        correct: false,
        feedback:
          "PPIs reduce stomach acid production and treat acid reflux — they have no role in treating diarrhoea.",
      },
    ],
    correctFeedback:
      "Loperamide slows intestinal motility to reduce stool frequency, while ORS replaces fluids and electrolytes lost through diarrhoea. The perfect combination!",
    counsellingPoints: [
      {
        id: "c1",
        text: "Drink plenty of fluids — ORS is better than plain water for replacing electrolytes",
        correct: true,
      },
      {
        id: "c2",
        text: "Do not use loperamide if there is blood in the stool, fever, or you feel very unwell",
        correct: true,
      },
      {
        id: "c3",
        text: "See a GP if diarrhoea lasts more than 48–72 hours or you become dehydrated",
        correct: true,
      },
      {
        id: "c4",
        text: "Eat normally if tolerated — avoid starvation (the BRAT diet is outdated advice)",
        correct: true,
      },
      {
        id: "c5",
        text: "Loperamide can be taken for weeks without any concern",
        correct: false,
      },
      {
        id: "c6",
        text: "Request antibiotics from the pharmacy if not improving within 24 hours",
        correct: false,
      },
    ],
  },
  {
    id: "conjunctivitis",
    client: {
      name: "Fatima",
      age: 29,
      sprite: "/blobavatar/blob.doctor.blue.png",
      color: "#ef4444",
      complaint:
        "My right eye has been red, sticky and producing yellow-green discharge since this morning. It's not painful and my vision is fine. No contact lenses.",
      flags: [],
    },
    medications: [
      {
        id: "chloramphenicol-drops",
        name: "Chloramphenicol 0.5% eye drops",
        category: "Topical antibiotic",
        correct: true,
      },
      {
        id: "aciclovir-eye",
        name: "Aciclovir 3% eye ointment",
        category: "Topical antiviral",
        correct: false,
        feedback:
          "Aciclovir eye ointment treats herpes simplex keratitis — a serious condition presenting with pain and reduced vision. The sticky discharge here points to bacterial conjunctivitis.",
      },
      {
        id: "loratadine",
        name: "Loratadine 10 mg",
        category: "Oral antihistamine",
        correct: false,
        feedback:
          "Loratadine treats allergic conjunctivitis (itchy, watery eyes, bilateral) — the purulent discharge here is characteristic of bacterial infection, not allergy.",
      },
      {
        id: "hydrocortisone",
        name: "Hydrocortisone 1% cream",
        category: "Topical corticosteroid",
        correct: false,
        feedback:
          "Topical steroids should never be applied to the eye without specialist assessment — they can mask serious infection or worsen herpes keratitis.",
      },
    ],
    correctFeedback:
      "Chloramphenicol 0.5% eye drops are first-line OTC treatment for bacterial conjunctivitis. They have broad-spectrum antibacterial coverage and are available without prescription for adults and children over 2.",
    counsellingPoints: [
      {
        id: "c1",
        text: "Instil 1 drop into the affected eye every 2 hours while awake, reducing to 4 times daily once improving — continue for 5 days",
        correct: true,
      },
      {
        id: "c2",
        text: "Wash hands before and after application; avoid touching the dropper tip to the eye",
        correct: true,
      },
      {
        id: "c3",
        text: "Clean the eye gently with cooled boiled water and cotton wool before each drop",
        correct: true,
      },
      {
        id: "c4",
        text: "Return if no improvement in 48 hours, vision changes, or eye becomes painful",
        correct: true,
      },
      {
        id: "c5",
        text: "Share the bottle with family members to treat the whole household",
        correct: false,
      },
      {
        id: "c6",
        text: "Continue wearing contact lenses as normal throughout treatment",
        correct: false,
      },
    ],
  },
  {
    id: "verruca",
    client: {
      name: "Callum",
      age: 14,
      sprite: "/blobavatar/blob.beerman.png",
      color: "#84cc16",
      complaint:
        "I've had a painful lump on the sole of my foot for about 2 months. It looks like it has small black dots in it. My PE teacher thinks it might be a verruca.",
      flags: [],
    },
    medications: [
      {
        id: "salicylic-acid",
        name: "Salicylic acid 16% gel (Bazuka)",
        category: "Keratolytic",
        correct: true,
      },
      {
        id: "terbinafine",
        name: "Terbinafine 1% cream",
        category: "Antifungal",
        correct: false,
        feedback:
          "Terbinafine treats fungal infections like athlete's foot — it has no activity against the human papillomavirus (HPV) that causes verrucas.",
      },
      {
        id: "fusidic-acid",
        name: "Fusidic acid cream",
        category: "Topical antibiotic",
        correct: false,
        feedback:
          "Fusidic acid treats bacterial skin infections and has no effect on viral warts or verrucas.",
      },
      {
        id: "hydrocortisone",
        name: "Hydrocortisone 1% cream",
        category: "Topical corticosteroid",
        correct: false,
        feedback:
          "Hydrocortisone reduces inflammation but has no antiviral properties and will not treat a verruca.",
      },
    ],
    correctFeedback:
      "Salicylic acid is first-line treatment for verrucas — it works by softening and breaking down the thickened skin (keratolysis), gradually destroying the infected tissue. Treatment takes weeks to months.",
    counsellingPoints: [
      {
        id: "c1",
        text: "Soak the foot in warm water for 5 minutes, then file away dead skin with an emery board before applying the gel",
        correct: true,
      },
      {
        id: "c2",
        text: "Apply once daily and cover with a plaster — treatment can take 12 weeks or more",
        correct: true,
      },
      {
        id: "c3",
        text: "Do not share emery boards or nail files — the virus is contagious",
        correct: true,
      },
      {
        id: "c4",
        text: "Wear flip-flops in communal areas like changing rooms to reduce spread to others",
        correct: true,
      },
      {
        id: "c5",
        text: "Apply the gel to the surrounding healthy skin as a preventative",
        correct: false,
      },
      {
        id: "c6",
        text: "If it doesn't clear in 2 weeks, it definitely needs surgical removal",
        correct: false,
      },
    ],
  },
  {
    id: "sore-throat",
    client: {
      name: "Lena",
      age: 33,
      sprite: "/blobavatar/blob.doctor.blue.png",
      color: "#f472b6",
      complaint:
        "I have a painful, raw sore throat since yesterday. No fever, no swollen glands, no pus. I feel otherwise okay. Probably just the start of a cold.",
      flags: [],
    },
    medications: [
      {
        id: "benzydamine",
        name: "Benzydamine 0.15% mouthwash / spray",
        category: "Anti-inflammatory analgesic (topical)",
        correct: true,
      },
      {
        id: "amoxicillin",
        name: "Amoxicillin 500 mg",
        category: "Antibiotic",
        correct: false,
        feedback:
          "Most sore throats are viral — antibiotics are not appropriate here and are not available OTC. The Centor criteria (fever, exudate, lymphadenopathy, no cough) should guide referral for throat swab and potential antibiotics.",
      },
      {
        id: "omeprazole",
        name: "Omeprazole 20 mg",
        category: "Proton pump inhibitor",
        correct: false,
        feedback:
          "Omeprazole reduces gastric acid — it is entirely unrelated to the management of acute viral pharyngitis.",
      },
      {
        id: "diphenhydramine",
        name: "Diphenhydramine 25 mg",
        category: "Sedating antihistamine",
        correct: false,
        feedback:
          "Sedating antihistamines treat allergic symptoms and insomnia — they have no meaningful analgesic effect on throat pain.",
      },
    ],
    correctFeedback:
      "Benzydamine is a topical NSAID with local analgesic and anti-inflammatory properties — it provides effective pain relief directly at the throat mucosa without systemic absorption.",
    counsellingPoints: [
      {
        id: "c1",
        text: "Gargle or spray every 1.5–3 hours as needed — do not swallow",
        correct: true,
      },
      {
        id: "c2",
        text: "Paracetamol or ibuprofen can be taken alongside for additional systemic pain relief",
        correct: true,
      },
      {
        id: "c3",
        text: "See GP if sore throat is severe, lasts more than 5 days, or is associated with high fever, difficulty swallowing or breathing",
        correct: true,
      },
      {
        id: "c4",
        text: "Stay hydrated — warm drinks and honey can be soothing",
        correct: true,
      },
      {
        id: "c5",
        text: "Swallow the spray directly for faster systemic effect",
        correct: false,
      },
      {
        id: "c6",
        text: "You need antibiotics — a viral sore throat will not improve without them",
        correct: false,
      },
    ],
  },
  {
    id: "nasal-congestion",
    client: {
      name: "Rory",
      age: 40,
      sprite: "/blobavatar/blob.moneyman.png",
      color: "#0891b2",
      complaint:
        "I've had a completely blocked nose for 3 days — part of a cold. It's affecting my sleep. No fever, no facial pain. Just needs something to clear it fast.",
      flags: [],
    },
    medications: [
      {
        id: "xylometazoline",
        name: "Xylometazoline 0.1% nasal spray",
        category: "Topical decongestant (alpha-agonist)",
        correct: true,
      },
      {
        id: "loratadine",
        name: "Loratadine 10 mg",
        category: "Non-drowsy antihistamine",
        correct: false,
        feedback:
          "Loratadine is best for allergic rhinitis (sneezing, itch, watery eyes). For a blocked nose from a cold, a topical decongestant gives faster, more targeted relief.",
      },
      {
        id: "sodium-citrate",
        name: "Sodium citrate sachets",
        category: "Urinary alkalinising agent",
        correct: false,
        feedback:
          "Sodium citrate alkalinises the urine and treats cystitis symptoms — it has no decongestant effect whatsoever.",
      },
      {
        id: "macrogol",
        name: "Macrogol sachets",
        category: "Osmotic laxative",
        correct: false,
        feedback:
          "Macrogol is a laxative for constipation — completely unrelated to nasal congestion.",
      },
    ],
    correctFeedback:
      "Xylometazoline is an alpha-adrenergic agonist that constricts nasal blood vessels, rapidly reducing swelling of the nasal mucosa. It is fast-acting and effective for short-term relief.",
    counsellingPoints: [
      {
        id: "c1",
        text: "Use 1–2 sprays in each nostril up to 3 times daily",
        correct: true,
      },
      {
        id: "c2",
        text: "Do not use for more than 5–7 days — prolonged use causes rebound congestion (rhinitis medicamentosa)",
        correct: true,
      },
      {
        id: "c3",
        text: "Avoid in patients with hypertension, ischaemic heart disease or hyperthyroidism",
        correct: true,
      },
      {
        id: "c4",
        text: "Steam inhalation and saline nasal rinses can be used alongside for additional comfort",
        correct: true,
      },
      {
        id: "c5",
        text: "Safe to use for months continuously — stops working so just increase the dose",
        correct: false,
      },
      {
        id: "c6",
        text: "Swallow the nasal spray for a faster systemic effect",
        correct: false,
      },
    ],
  },
  {
    id: "mouth-ulcer",
    client: {
      name: "Sophie",
      age: 21,
      sprite: "/blobavatar/blob.doctor.blue.png",
      color: "#a78bfa",
      complaint:
        "I have a painful ulcer on the inside of my cheek — it appeared 2 days ago. Small, round, white centre with a red halo. I get these a few times a year when I'm stressed.",
      flags: [],
    },
    medications: [
      {
        id: "bonjela",
        name: "Bonjela gel (choline salicylate + cetalkonium)",
        category: "Topical analgesic / antiseptic",
        correct: true,
      },
      {
        id: "chloramphenicol",
        name: "Chloramphenicol 0.5% eye drops",
        category: "Topical antibiotic (ophthalmic)",
        correct: false,
        feedback:
          "Chloramphenicol eye drops are licensed for ocular use only — they are not appropriate for mouth ulcers and are not formulated for oral mucosal application.",
      },
      {
        id: "aciclovir-cream",
        name: "Aciclovir 5% cream",
        category: "Topical antiviral",
        correct: false,
        feedback:
          "Aciclovir cream is for herpes simplex cold sores on the lip. Recurrent aphthous ulcers inside the mouth are not caused by HSV and won't respond to aciclovir.",
      },
      {
        id: "hydrocortisone",
        name: "Hydrocortisone 2.5 mg oromucosal tablets",
        category: "Topical corticosteroid (oromucosal)",
        correct: false,
        feedback:
          "Hydrocortisone oromucosal tablets (Corlan pellets) are actually appropriate for aphthous ulcers — however Bonjela provides immediate analgesia for pain relief which is what this patient needs OTC.",
      },
    ],
    correctFeedback:
      "Bonjela contains choline salicylate (analgesic/anti-inflammatory) and cetalkonium chloride (antiseptic). It provides fast local pain relief for minor aphthous ulcers.",
    counsellingPoints: [
      {
        id: "c1",
        text: "Apply a small amount directly to the ulcer and surrounding gum 3–4 times daily",
        correct: true,
      },
      {
        id: "c2",
        text: "Most aphthous ulcers heal within 7–14 days without treatment",
        correct: true,
      },
      {
        id: "c3",
        text: "Avoid spicy foods, acidic drinks, and hard foods that can irritate the ulcer",
        correct: true,
      },
      {
        id: "c4",
        text: "See GP or dentist if the ulcer is larger than 1 cm, persists beyond 3 weeks, or is painless",
        correct: true,
      },
      {
        id: "c5",
        text: "Do not use in children under 16 who have a viral illness — risk of Reye's syndrome (contains salicylate)",
        correct: true,
      },
      {
        id: "c6",
        text: "Apply several times an hour throughout the day for fastest healing",
        correct: false,
      },
    ],
  },
  {
    id: "nappy-rash",
    client: {
      name: "Mrs. Kowalski",
      age: 30,
      sprite: "/blobavatar/blob.doctor.blue.png",
      color: "#fb923c",
      complaint:
        "My 8-month-old has a red, inflamed rash in the nappy area. It started 2 days ago. The skin looks sore but there are no blisters or satellite lesions. No fever.",
      flags: ["Treating an infant (8 months)"],
    },
    medications: [
      {
        id: "metanium",
        name: "Metanium barrier cream (titanium dioxide)",
        category: "Barrier preparation",
        correct: true,
      },
      {
        id: "hydrocortisone",
        name: "Hydrocortisone 1% cream",
        category: "Topical corticosteroid",
        correct: false,
        feedback:
          "Hydrocortisone should not be used on facial or nappy area skin in infants without medical supervision — thin skin absorbs steroids more readily, risking adrenal suppression with regular use.",
      },
      {
        id: "clotrimazole",
        name: "Clotrimazole 1% cream",
        category: "Antifungal",
        correct: false,
        feedback:
          "Clotrimazole would be appropriate if there were signs of Candida superinfection (satellite lesions, persistent rash unresponsive to barrier cream). Without those features, a barrier preparation is first-line.",
      },
      {
        id: "fusidic-acid",
        name: "Fusidic acid cream",
        category: "Topical antibiotic",
        correct: false,
        feedback:
          "Fusidic acid is for bacterial skin infections. Simple nappy rash is an irritant contact dermatitis and does not require an antibiotic.",
      },
    ],
    correctFeedback:
      "Metanium contains titanium dioxide, which forms a water-repellent barrier protecting the skin from moisture and stool irritants. It's first-line for simple irritant nappy rash.",
    counsellingPoints: [
      {
        id: "c1",
        text: "Apply a thin layer to clean, dry skin at each nappy change",
        correct: true,
      },
      {
        id: "c2",
        text: "Leave the nappy off for short periods to air the skin when safe to do so",
        correct: true,
      },
      {
        id: "c3",
        text: "Clean the nappy area gently with water and cotton wool — avoid wipes containing alcohol or fragrance",
        correct: true,
      },
      {
        id: "c4",
        text: "See GP if the rash spreads, develops satellite spots (suggests Candida), blisters, or does not improve after 3 days",
        correct: true,
      },
      {
        id: "c5",
        text: "Apply a thick layer and leave it on for 24 hours without changing the nappy",
        correct: false,
      },
      {
        id: "c6",
        text: "Use talcum powder alongside to keep the area dry",
        correct: false,
      },
    ],
  },
  {
    id: "earwax",
    client: {
      name: "Arthur",
      age: 68,
      sprite: "/blobavatar/blob.moneyman.png",
      color: "#a16207",
      complaint:
        "My left ear has felt blocked and muffled for about a week. No pain, no discharge, no dizziness. My GP said I have wax build-up last year and this feels the same.",
      flags: [],
    },
    medications: [
      {
        id: "olive-oil",
        name: "Olive oil ear drops",
        category: "Ear wax softener",
        correct: true,
      },
      {
        id: "xylometazoline",
        name: "Xylometazoline 0.1% nasal spray",
        category: "Nasal decongestant",
        correct: false,
        feedback:
          "Xylometazoline is a nasal decongestant for blocked nose — it cannot be used in the ear and will not soften earwax.",
      },
      {
        id: "chloramphenicol-drops",
        name: "Chloramphenicol 0.5% eye drops",
        category: "Topical antibiotic (ophthalmic)",
        correct: false,
        feedback:
          "Chloramphenicol eye drops are for bacterial conjunctivitis — they are not formulated for the ear canal and won't help with wax impaction.",
      },
      {
        id: "sodium-citrate",
        name: "Sodium citrate sachets",
        category: "Urinary alkalinising agent",
        correct: false,
        feedback:
          "Sodium citrate is used orally for urinary symptoms — it has no role in ear wax management.",
      },
    ],
    correctFeedback:
      "Olive oil ear drops are an effective, safe first-line treatment for earwax build-up. They soften and lubricate the wax, facilitating natural clearance or syringing by the GP.",
    counsellingPoints: [
      {
        id: "c1",
        text: "Warm the drops to body temperature by holding the bottle in your hand for a few minutes before use",
        correct: true,
      },
      {
        id: "c2",
        text: "Tilt the head and instil 2–3 drops twice daily for up to 2 weeks",
        correct: true,
      },
      {
        id: "c3",
        text: "Stay with the ear tilted for 5–10 minutes after instilling to allow the oil to reach the wax",
        correct: true,
      },
      {
        id: "c4",
        text: "See your GP if symptoms don't improve after 2 weeks — syringing or microsuction may be needed",
        correct: true,
      },
      {
        id: "c5",
        text: "Use a cotton bud to push the softened wax deeper in to help it fall out",
        correct: false,
      },
      {
        id: "c6",
        text: "Do not use if the ear is painful or you have a known perforated eardrum",
        correct: true,
      },
    ],
  },
  {
    id: "acne",
    client: {
      name: "Tyler",
      age: 16,
      sprite: "/blobavatar/blob.beerman.png",
      color: "#f43f5e",
      complaint:
        "I've had spots on my face and forehead for about 6 months — mostly blackheads and some red inflamed spots. No cysts. Nothing over-the-counter has worked so far.",
      flags: [],
    },
    medications: [
      {
        id: "benzoyl-peroxide",
        name: "Benzoyl peroxide 5% gel (Oxy/PanOxyl)",
        category: "Topical antimicrobial / keratolytic",
        correct: true,
      },
      {
        id: "hydrocortisone",
        name: "Hydrocortisone 1% cream",
        category: "Topical corticosteroid",
        correct: false,
        feedback:
          "Topical steroids should not be used on acne — they can worsen acne by promoting follicular occlusion and may cause steroid-induced acneiform rash.",
      },
      {
        id: "aciclovir-cream",
        name: "Aciclovir 5% cream",
        category: "Topical antiviral",
        correct: false,
        feedback:
          "Aciclovir is for herpes simplex cold sores — it has no effect on acne vulgaris, which is caused by Cutibacterium acnes and sebum overproduction.",
      },
      {
        id: "clotrimazole",
        name: "Clotrimazole 1% cream",
        category: "Antifungal",
        correct: false,
        feedback:
          "Clotrimazole is for fungal infections — acne is not fungal and won't respond to antifungals. (Note: Malassezia folliculitis can look like acne but has distinct features.)",
      },
    ],
    correctFeedback:
      "Benzoyl peroxide releases free oxygen radicals that kill C. acnes bacteria and has keratolytic activity to unblock pores. It is a proven first-line OTC treatment for mild-to-moderate acne.",
    counsellingPoints: [
      {
        id: "c1",
        text: "Apply a thin layer to affected areas once daily initially — increase to twice daily if tolerated",
        correct: true,
      },
      {
        id: "c2",
        text: "Skin may become dry, red or peel initially — this often settles after 2–4 weeks",
        correct: true,
      },
      {
        id: "c3",
        text: "Benzoyl peroxide bleaches fabric — avoid contact with clothing, towels and bedding",
        correct: true,
      },
      {
        id: "c4",
        text: "Results take 6–8 weeks — do not give up after a few days",
        correct: true,
      },
      {
        id: "c5",
        text: "Apply thickly all over the face for maximum coverage",
        correct: false,
      },
      {
        id: "c6",
        text: "If the GP refers for antibiotics, stop the benzoyl peroxide immediately",
        correct: false,
      },
    ],
  },
];
